import { useEffect, useState } from "react";
import api from "@/lib/api";

export const BUILDER_PAGE = 40;

// THE JOB SCREENS' "WHICH TRUCK IS THIS FOR?" ON THE ONE TRUCK ENGINE (S4): builder trucks only, asked of the server
// (stock #, VIN, year, make, model, specs, serials, or the PO), with the true total so the list can say what it isn't
// showing. It used to filter whatever builder trucks the browser had loaded.
// box: the search-record box name (only a box whose words ARE a truck search); withPo: builder trucks that carry a PO.
export function useBuilderTrucks(q, enabled = true, { box = "", withPo = false } = {}) {
  const [res, setRes] = useState({ items: [], total: 0, loading: false });
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const term = (q || "").trim();
    const t = setTimeout(async () => {
      setRes((r) => ({ ...r, loading: true }));
      try {
        const { data } = await api.get("/truck-search", {
          params: { q: term, role: "builder", page_size: BUILDER_PAGE, facets: 0, box, with_po: withPo ? 1 : 0 } });
        if (live) setRes({ items: data.items || [], total: data.total ?? 0, loading: false });
      } catch { if (live) setRes({ items: [], total: 0, loading: false }); }
    }, term ? 250 : 0);
    return () => { live = false; clearTimeout(t); };
  }, [q, enabled, box, withPo]);
  return res;
}

// Enter on the box: a builder truck's own stock # typed exactly picks it (his rule); null = keep the list.
export async function exactBuilder(hit) {
  if (hit?.kind !== "truck") return null;
  const { data } = await api.get("/truck-search", {
    params: { q: hit.label, role: "builder", page_size: 5, facets: 0 } }).catch(() => ({ data: {} }));
  return (data.items || []).find((t) => t.id === hit.id) || null;
}
